export function monthCheck(value, manipulatedDate) {
    const montharr = value.month.split(value.DELIMITER_MON);
    const monthisincluded = montharr.includes(value.getMonthAbbreviation([manipulatedDate.month()], "string", undefined, ","));
    //Check month field
    if (value.month === "*" || value.month === "1") {
        return true;
    }
    if (typeof value.DELIMITER_MON !== "undefined") {
        if (value.DELIMITER_MON === "/") {
            //Month is start and interval
            const month = manipulatedDate.month() + 1;
            // Normalize to 12-month cycle
            const offset = (month - parseInt(montharr[0]) + 12) % 12;
            // Check divisibility
            return offset % parseInt(montharr[1]) === 0;
        }
        //Month is comma separated list
        if (value.DELIMITER_MON === "," && monthisincluded) {
            return true;
        }
        //Month is range
        if (value.DELIMITER_MON === "-" &&
            manipulatedDate.month() > parseInt(montharr[0]) &&
            manipulatedDate.month() < parseInt(montharr[1])) {
            return true;
        }
    }
    else {
        //Month is a single month
        const currentMonthAbbr = value.getMonthAbbreviation([manipulatedDate.month()], "string", undefined, ",");
        if (currentMonthAbbr === montharr[0]) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=monthCheck.js.map